export default function(instance) {
    instance.extend({
        classes: {
            //outer: "mb-4",
            //input(context) {
            //   switch (context.classification) {
            //        case "button":
            //            return "w-full px-4 py-2 rounded bg-green-500 text-white hover:bg-green-600";
            //        default:
            //            return "border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1";
            //    }
            //},
            //label: "font-medium text-sm",
            //help: "text-xs mb-1 text-gray-600",
            //error: "text-red-700 text-xs mb-1"
        }
    });
}
